(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function init(root) {
    if (root.dataset.pvReady) return;
    root.dataset.pvReady = 'true';
    var jsonEl = root.querySelector('[data-pv-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var moneyFormat = root.dataset.moneyFormat;
    var idInput = root.querySelector('[data-pv-variant-id]');
    var priceEl = root.querySelector('[data-pv-price]');
    var compareEl = root.querySelector('[data-pv-compare]');
    var submit = root.querySelector('[data-pv-submit]');
    var fieldsets = root.querySelectorAll('[data-pv-option]');

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function update() {
      var values = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.labelUnavailable;
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.labelAdd : submit.dataset.labelSoldout;
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  }

  function boot() { document.querySelectorAll('[data-pv-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
